import React from 'react'
import { Link } from 'react-router-dom'
import './Drawer.scss'
import { useContext } from 'react';
import { Context } from '../../../context';
import { auth } from '../../../firebaseConfig';

const Drawer = props => {

    const { user } = useContext(Context)


    const links = [
    ]

    if (user) {
        links.push(
            { to: 'todo', label: 'Список дел' },
            { to: '/about', label: 'Информация' },

        )

    } else {
        links.push(
            { to: '/auth', label: 'Авторизация' },
            { to: '/reg', label: 'Регистрация' },
            { to: '/about', label: 'Информация' },
        )

    }

    return (
        <>
            {props.isOpen ? (
                <div className='drawer'>
                    <div className='drawer__links'>
                        {links.map(link => <Link key={Math.random()} to={link.to}>{link.label}</Link>)}
                        {user ? <Link key={Math.random()} to='/logout' onClick={() => auth.signOut()}>Выход</Link> : null}
                    </div>
                </div>

            ) : null}

        </>
    )
}


export default (Drawer)